import { resolveMasteryColorForPercentage } from "@memorang/helpers/common";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppConfig } from "../../../../../contexts/AppConfigContext";
import { useAppTheme } from "../../../../../useAppTheme";
import Box from "../../../../Box";
import { useScoreToneColors } from "./reorder-paragraph-utils";
import { formatPoints, getScoreTone } from "./review-helpers";

export const ReviewScoreChip = ({
	earnedPoints,
	maxPoints,
}: {
	earnedPoints?: number;
	maxPoints?: number;
}) => {
	const { t } = useTranslation();
	const theme = useAppTheme();
	const { masteryLevels } = useAppConfig();
	const scoreTones = useScoreToneColors();
	if (earnedPoints === undefined || maxPoints === undefined) {
		return null;
	}
	const masteryColor =
		maxPoints > 0
			? resolveMasteryColorForPercentage(
					(earnedPoints / maxPoints) * 100,
					masteryLevels,
					theme.dark,
				)
			: undefined;
	const colors = masteryColor
		? { background: masteryColor, foreground: theme.colors.onPrimary }
		: scoreTones[getScoreTone(earnedPoints, maxPoints)];
	return (
		<Box
			paddingHorizontal={8}
			paddingVertical={6}
			borderRadius={theme.roundness * 2}
			backgroundColor={colors.background}
			alignItems="center"
		>
			<Text variant="labelMedium" style={{ color: colors.foreground }}>
				{t("testDriver.itemTypes.reorderParagraph.pointsBadge", {
					earned: formatPoints(earnedPoints),
					max: formatPoints(maxPoints),
				})}
			</Text>
		</Box>
	);
};

export const ReviewScoreRow = ({
	earnedPoints,
	maxPoints,
}: {
	earnedPoints?: number;
	maxPoints?: number;
}) => {
	if (earnedPoints === undefined || maxPoints === undefined) {
		return null;
	}
	return (
		<Box flexDirection="row" justifyContent="flex-end">
			<ReviewScoreChip earnedPoints={earnedPoints} maxPoints={maxPoints} />
		</Box>
	);
};
